import * as yup from "yup";
import {
    nameRule,
    emailRule,
    textRule,
    phoneRule,
} from "../commonRules";

export const requestDemoSchema = yup.object().shape({
    first_name: nameRule("First Name", { required: true }),
    last_name: nameRule("Last Name", { required: true }),
    email: emailRule("Work Email", { required: true }),
    company: textRule("Company / Organization", { required: true }),
    industry: textRule("Industry", { required: true }),
    designation: textRule("Designation", { required: true }),
    phone: phoneRule("Contact Number", { required: true }),
    countryCode: yup.string().required("Country code is required"),
});

export default requestDemoSchema;
